export default {
    message: {
        tiers: {
            t1: {
                label: "Autonome",
                desc: "<p>Accès unifié à l’ensemble des applications virtuelles, Web et SaaS. Protège les utilisateurs, les applications et les données à l’aide de contrôles de sécurité contextuels de bout en bout.</p><p>Fournit un proxy sans VPN et une authentification unique pour les applications Web, SaaS, virtuelles et mobiles, ainsi qu’une protection contre le contenu malveillant, les enregistreurs de frappe et les logiciels malveillants capturant les données à l’écran.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Solution complète d’espace de travail pour les collaborateurs ayant besoin d’un espace de travail digital assorti d’une sécurité granulaire, mais qui n’ont pas besoin d’applications et de postes virtuels.</p><p>Comprend les fonctionnalités de Workspace Standard, ainsi que des contrôles de sécurité avancés pour les SaaS et le Web, la gestion unifiée des terminaux et Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Solution complète d’espace de travail comprenant des options de déploiement hybride pour Citrix Virtual Apps and Desktops.</p><p>Comprend les fonctionnalités de Workspace Premium, ainsi qu’une option de gestion de cloud pour Citrix Virtual Apps and Desktops.</p>"
            }
        }
    }
}